import React from 'react';

import { PlanUnit, PlanUnitLink } from '../types';

import { useGetPlanUnitDetails } from './utils/useGetPlanUnitDetails';

import { SectionSkeleton } from 'components/shared/MultiStepForm/Skeletons/SectionSkeleton';

import { LinkPlanUnitForm } from './LinkPlanUnitForm';
import { HierarchyPlanUnit } from './utils/treeHierarchy';

interface Props {
  onClose: () => void;
  selectedRow: PlanUnit;
  mode?: PlanUnitLink;
  hierarchy: PlanUnit[] | HierarchyPlanUnit[] | undefined;
}

export const LinkPlanUnitDetailsLoaderFeedback: React.FC<Props> = ({
  mode,
  selectedRow,
  onClose,
  hierarchy
}) => {
  const { data, isFetching } = useGetPlanUnitDetails(selectedRow);

  return isFetching ? (
    <SectionSkeleton />
  ) : (
    <LinkPlanUnitForm
      onClose={onClose}
      mode={mode}
      details={data ?? []}
      selectedRow={selectedRow}
      hierarchy={hierarchy}
    />
  );
};
